// accordion
const accordions = document.querySelectorAll(".jsAccordionItem") as NodeListOf<HTMLElement>;

const getElemDistance = (elem) => {
    let location = 0;
    if (elem.offsetParent) {
        do {
            location += elem.offsetTop;
            elem = elem.offsetParent;
        } while (elem);
    }
    return location >= 0 ? location : 0;
};
 
const openAccordion = (accordion, content) => {
    accordion.classList.add("accordion--active");
    content.style.maxHeight = content.scrollHeight + "px";
    window.scrollTo(0, accordion.getAttribute("data-top-distance") - 50)
};
 
const closeAccordion = (accordion, content) => {
    accordion.classList.remove("accordion--active");
    content.style.maxHeight = null;
};
 
accordions.forEach(accordion => {
    const intro = <HTMLElement>accordion.querySelector(".jsAccordionTitle");
    const content = <HTMLElement>accordion.querySelector(".jsAccordionContent");
    accordion.setAttribute("data-top-distance", `${getElemDistance(accordion)}`);
 
    intro!.onclick = () => {
        if (content!.style.maxHeight) {
            closeAccordion(accordion, content);
        } else {
            accordions.forEach((accordion) => closeAccordion(accordion, accordion.querySelector(".jsAccordionContent")));
            openAccordion(accordion, content);
        }
    };
 
});
